<template>
	<el-backtop :bottom="100" :visibility-height="50" style="
	        width: 68px;
	        height: 68px;
			border: none;
			background: transparent;
	    ">
		<el-button id="up_btn" class="el-icon-up" @click="backtopbtn()">
		</el-button>
	</el-backtop>
</template>

<script>
	// @ is an alias to /src
	export default {
		components: {},

		methods: {
			backtopbtn() {
				document.getElementById("up_btn").blur();
			},
		}
	}
</script>

<style>
	@import url(../assets/css/index.css);
</style>
